import script from "./resourceVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./resourceVideo.vue?vue&type=script&setup=true&lang=js"

import "./resourceVideo.vue?vue&type=style&index=0&id=4e1bec59&scoped=true&lang=css"
import "./resourceVideo.vue?vue&type=style&index=1&id=4e1bec59&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1bec59"]])

export default __exports__